import React, { Suspense, useLayoutEffect,createContext,useState } from 'react'
import { BrowserRouter as Router, Route, withRouter } from 'react-router-dom';
import SellDetails from "./components/pages/SellDetails";
import i18n from 'i18next';

// Preloader
const Preloader = React.lazy(() => import("./components/layouts/Preloader"));


// Pages
const Homethree = React.lazy(() => import("./components/pages/Homethree"));
const Roomgrid = React.lazy(() => import("./components/pages/Roomgrid"));
const Roomdetails = React.lazy(() => import("./components/pages/Roomdetails"));
const Roomlist = React.lazy(() => import("./components/pages/Roomlist"));
const Contact = React.lazy(() => import("./components/pages/Contact"));
const About = React.lazy(() => import("./components/pages/About"));
//const FullPage = React.lazy(() => import("./components/pages/Creative-carousel"));
const Sale = React.lazy(() => import("./components/pages/Offers"));
const PageNotFound = React.lazy(() => import("./components/pages/PageNotFound"));
const Faq = React.lazy(() => import("./components/pages/Faq"));
const Cookie = React.lazy(() => import("./components/pages/CookiePolicyPrivacy"));
const LavoraConNoi = React.lazy(() => import("./components/pages/LavoraConNoi"));




// Scroll to Top
const ScrollToTop = withRouter(({ children, location: { pathname } }) => {
  useLayoutEffect(() => {
    window.scrollTo(0, 0)
  }, [pathname])

  return children || null
})

export const LanguageContext = createContext();

function App() {
  const [language, setLanguage] = useState(i18n.language);
  const [loading, setLoading] = useState(true);

  const setLoad = (val) => {
    setLoading(val)
  };

  return (
    <Router>
      <LanguageContext.Provider value={{ language, setLanguage }}>
      <Suspense fallback={<div></div>}>
        <ScrollToTop>
          <Preloader loading={loading} setLoad={setLoad} />

          <Route path="/home" exact component={Homethree} />
          <Route path="/" exact component={Homethree} />
          <Route path="/room/search" exact component={Roomgrid} />
          <Route path="/room/details/:id" exact component={Roomdetails} />
          <Route path="/room/details-sell/:id" exact component={SellDetails} />
          <Route path="/room/room-list" exact component={Roomlist} />
          <Route path="/about" exact component={About} />
          <Route path="/contact" exact component={Contact} />
          {/*<Route path="/sale" exact component={Sale} />*/}
          {/*<Route path="/faq" exact component={Faq} />*/}
          <Route path="/cookie" exact component={Cookie} />
          {/*<Route path="/job" exact component={LavoraConNoi} />*/}
          {/*<Route path="/home-slider" component={FullPage} />*/}
          {/*<Route component={PageNotFound} />*/}

        </ScrollToTop>
      </Suspense>
      </LanguageContext.Provider>
    </Router>
  );
}

export default App;
